export default from './input-radio';



// WEBPACK FOOTER //
// ./app/components/input-radio/index.js